/**
 * Reconhece link de vídeo do YouTube e do Vimeo, que é o que a Vista aceita.
 *
 * O backend valida a mesma coisa e é ele quem manda - aqui é só para o usuário saber na hora, em vez
 * de descobrir no erro do submit. Uma URL de MP4, inclusive do nosso bucket, não é vídeo para a
 * Vista: ela responde "não pertence ao youtube ou vimeo".
 */

const YOUTUBE_HOSTS = ['youtube.com', 'm.youtube.com', 'youtube-nocookie.com']
const YOUTUBE_ID = /^[A-Za-z0-9_-]{11}$/
const VIMEO_ID = /^\d{6,}$/

export function parseVideoUrl(rawUrl) {
  if (!rawUrl || !rawUrl.trim()) return null

  let url
  try {
    url = new URL(rawUrl.trim())
  } catch (e) {
    return null
  }

  const host = url.hostname.toLowerCase().replace(/^www\./, '')
  const segments = url.pathname.split('/').filter((it) => it)

  if (host === 'youtu.be') return youtube(segments[0])

  if (YOUTUBE_HOSTS.includes(host)) {
    // /watch?v=<id>, e /embed/<id>, /shorts/<id>, /live/<id>
    return url.pathname.startsWith('/watch')
      ? youtube(url.searchParams.get('v'))
      : youtube(segments[1])
  }

  if (host === 'vimeo.com' || host === 'player.vimeo.com') {
    const numeric = segments.filter((it) => VIMEO_ID.test(it))
    return numeric.length ? { provider: 'VIMEO', videoId: numeric[numeric.length - 1] } : null
  }

  return null
}

export function isSupportedVideoUrl(rawUrl) {
  return parseVideoUrl(rawUrl) !== null
}

/** Thumbnail sem chamar API: o YouTube serve por id. O Vimeo exige oEmbed, então fica sem. */
export function videoThumbnail(video) {
  if (!video) return null

  const parsed = video.provider_video_id
    ? { provider: video.provider, videoId: video.provider_video_id }
    : parseVideoUrl(video.url)

  if (!parsed || parsed.provider !== 'YOUTUBE') return null

  return `https://img.youtube.com/vi/${parsed.videoId}/mqdefault.jpg`
}

function youtube(videoId) {
  return videoId && YOUTUBE_ID.test(videoId) ? { provider: 'YOUTUBE', videoId } : null
}
